module.exports = __webpack_public_path__ + "img/icon-award.3380db94.svg";